/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { VisitPackageStageDto } from './visit-package-stage-dto';

/**
 * 
 * @export
 * @interface VisitPackageTemplateDto
 */
export interface VisitPackageTemplateDto {
    /**
     * 
     * @type {boolean}
     * @memberof VisitPackageTemplateDto
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof VisitPackageTemplateDto
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof VisitPackageTemplateDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof VisitPackageTemplateDto
     */
    'name': string;
    /**
     * 
     * @type {Array<VisitPackageStageDto>}
     * @memberof VisitPackageTemplateDto
     */
    'stages': Array<VisitPackageStageDto>;
    /**
     * 
     * @type {string}
     * @memberof VisitPackageTemplateDto
     */
    'type': VisitPackageTemplateDtoTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum VisitPackageTemplateDtoTypeEnum {
    Epilepsy = 'EPILEPSY',
    Consultation = 'CONSULTATION'
}


